module.exports = __webpack_public_path__ + "img/List.f1500633.svg";